// Module
var code = "<react-component name=\"StyleList\"></react-component>\n";
// Exports
module.exports = code;